import { atom } from 'jotai';
import { LandsatMosaic_Item } from '~/common/typescript/apis/RemoteImageAlertAPIs';

export const landsatMosaicItemsLEFTAtom = atom<LandsatMosaic_Item[]>([]);
export const landsatMosaicItemsRIGHTAtom = atom<LandsatMosaic_Item[]>([]);

export const landsatMosaicLoadingAtom = atom<{
  isLoading: boolean;
  text: string;
}>({
  isLoading: false,
  text: '',
});

export const landsatMosaicYearAtom = atom<number | undefined>(undefined);
export const landsatMosaicPeriodAtom = atom<number | undefined>(undefined);
